// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/connections/firstparty/v2/get_connection.proto

/* eslint-disable */
import { ApiResponseData } from "./common";

/** No request body. The organization_id is passed in the header. */
export interface ApiGetConnectionRequest {
}

/** Response message for GetConnection. */
export interface ApiGetConnectionResponse {
  /** The data wrapper by JSONAPIArray spec. */
  readonly data: readonly ApiResponseData[];
}

export const ApiGetConnectionRequest: MessageFns<ApiGetConnectionRequest> = {
  fromJSON(_: any): ApiGetConnectionRequest {
    return {};
  },

  toJSON(_: ApiGetConnectionRequest): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiGetConnectionResponse: MessageFns<ApiGetConnectionResponse> = {
  fromJSON(object: any): ApiGetConnectionResponse {
    return {
      data: globalThis.Array.isArray(object?.data)
        ? object.data.map((e: any) => ApiResponseData.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiGetConnectionResponse): unknown {
    const obj: any = {};
    if (message.data?.length) {
      obj.data = message.data.map((e) => ApiResponseData.toJSON(e));
    }
    return obj;
  },
};

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
